import React from 'react';
import * as Styles from './ChooseSiteOptionBuilderV2.styles';
import { Button, IconMagicWand } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';
import { GradientButton } from '@/pages/Studio/components';
import bannerVideo from '@/media/onboarding/onboarding-sitebuilder-v2.webm';

const ChooseSiteOptionBuilderV2 = ({
  banner,
  blockOptions,
}) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width <= 600;
  return (
    <>
      <Styles.BannerWrapper>
        <Styles.Container>
          <Styles.Video autoPlay loop muted playsInline data-testid="banner-video">
            <source src={bannerVideo} type="video/webm" />
          </Styles.Video>
          <Styles.BannerContent>
            <Styles.Title>
              {banner.title}
              <IconMagicWand color="primaryUltralight" />
            </Styles.Title>
            <Styles.Description>{banner.description}</Styles.Description>
            <Styles.ButtonsWrapper>
              <Button
                label={banner.button.label}
                onClick={banner.button.onClick}
                variant="secondary"
                size="large"
                width={isMobile ? 'full' : 'fit'}
              />
            </Styles.ButtonsWrapper>
          </Styles.BannerContent>
        </Styles.Container>
      </Styles.BannerWrapper>

      <Styles.Container>
        {blockOptions.map(option => (
          <Styles.Option key={option.title}>
            <Styles.OptionHeader>
              <Styles.OptionTitleWrapper>
                <Styles.OptionTitle>{option.title}</Styles.OptionTitle>
                {option.icon}
              </Styles.OptionTitleWrapper>
              <Styles.OptionSubtitle>{option.subtitle}</Styles.OptionSubtitle>
            </Styles.OptionHeader>
            <Styles.OptionDescription>{option.description}</Styles.OptionDescription>
            <Styles.OptionButtonWrapper>
              <GradientButton
                testId={option.buttonTestId}
                label={option.buttonLabel}
                size="lg"
                variant="quaternary"
                iconRight={option.buttonIcon}
                width="fit-content"
                onClick={option.buttonClick}
              />
              {option.buttonAuxLabel && (
                <Button
                  label={option.buttonAuxLabel}
                  size="large"
                  variant="secondary"
                  version="v2"
                  width="fit-content"
                  onClick={option.buttonAuxClick}
                />
              )}
            </Styles.OptionButtonWrapper>
          </Styles.Option>
        ))}
      </Styles.Container>
    </>
  );
};

export default ChooseSiteOptionBuilderV2;
